import every from 'lodash/every';
import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { t } from '../../../../helpers/t';
import FilterWrapper from '../../FilterWrapper';
import { setMoreFiltersOpen } from '../../../../actions';

const MoreFilters = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    moreFiltersOpen: isMenuOpen
  } = useSelector((state) => state.searchFilters);

  const handleButtonClick = () => {
    dispatch(setMoreFiltersOpen(!isMenuOpen));
  };

  const dropdownFilters = [
    'duration',
    'space_type_ids',
    'position_types',
    'listing_feature_ids_contains_array',
  ];
  const isAFilterSet = !every(dropdownFilters, (filter) => !parameters[filter] || parameters[filter].length === 0);

  return (
    <FilterWrapper>
      <Button
        type={isAFilterSet ? 'primary' : 'default'}
        className="more-filters pr-2"
        onClick={handleButtonClick}
      >
        <span
          dangerouslySetInnerHTML={
            { __html: t('directives.listings.listingFilters.moreFilters') }
          }
        />
      <FontAwesomeIcon
        icon={isMenuOpen ? faAngleUp : faAngleDown}
        className="ml-2 text-xs mr-1 relative bottom-px"
      />
      </Button>
    </FilterWrapper>
  );
};

export default MoreFilters;
